exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact_1 {\r\n  white-space:nowrap;\r\n  line-height: 36px;\r\n  height: 36px;\r\n  border: 1px solid #dcdfe6;\r\n  padding: 0px 15px;\r\n  color: #000000;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-460670f2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketDetailLeft.vue
// module id = 731
// module chunks = 75